import { cn } from "@/lib/utils";
import { Loader2 } from "lucide-react";

interface LoadingOverlayProps {
  isVisible: boolean;
  message?: string;
  progress?: string;
  className?: string;
}

export function LoadingOverlay({ 
  isVisible, 
  message = "Processing...", 
  progress,
  className 
}: LoadingOverlayProps) {
  if (!isVisible) return null;

  return (
    <div 
      className={cn(
        "fixed inset-0 bg-background/80 backdrop-blur-sm z-50 flex items-center justify-center",
        "animate-fade-in",
        className
      )}
    >
      <div className="bg-card border border-border rounded-lg p-6 shadow-lg max-w-sm mx-4 text-center">
        <div className="flex flex-col items-center space-y-4">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
          <div className="space-y-2">
            <p className="text-sm font-medium text-foreground">{message}</p>
            {progress && (
              <p className="text-xs text-muted-foreground">{progress}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}